// extracted by mini-css-extract-plugin
export default {"App":"App_App__j-XAb","logo":"App_logo__kelS3","nav":"App_nav__zt3Eh","footer":"App_footer__EmZSd"};